import React, { useEffect, useState } from 'react';
import 'normalize.css';

import GlobalStyles from '../styles/GlobalStyles';
import Typography from '../styles/Typography';
import Grid from './Grid';
import GridMobil from './GridMobil';

export const mobileThreshold = 900;

function CheckIfIsMobile() {
  if (typeof window !== 'undefined') {
    if (window.innerWidth < mobileThreshold) {
      return true;
    }
  }
  return false;
}


export default function Layout({ children, location }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < mobileThreshold);
    };

    // Set the initial value
    handleResize();

    // Set up event listener
    window.addEventListener('resize', handleResize);

    // Clean up
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <GlobalStyles />
      <Typography />
      {isMobile ? (
        <GridMobil pageContent={children} location={location} />
      ) : (
        <Grid pageContent={children} location={location} />
      )}
    </>
  );
}
